module.exports = __webpack_public_path__ + "assets/img/ic-trash.c8e6d0f2.svg";